import { render, staticRenderFns } from "./communityactivity.vue?vue&type=template&id=5d1ef6b2&"
import script from "./communityactivity.vue?vue&type=script&lang=js&"
export * from "./communityactivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports